import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll cleanly to top whenever the router hits a new screen block
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
